module.exports = __webpack_public_path__ + "images/bannerPT-70cbc426a03e104955ec6fd9774bb6e7.png";